<script>
export default {
  props: {
    mobileMenuIsOpen: {
      type: Boolean,
      required: true,
    },
    isInSecondLevel: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["toggleMobileMenu", "backToFirstLevel"],
  components: {},
  computed: {
    buttonLabel() {
      return this.mobileMenuIsOpen && this.isInSecondLevel
        ? "Zurück zur ersten Ebene"
        : "Toggle menu";
    },
  },
  methods: {
    handleClick() {
      if (this.mobileMenuIsOpen && this.isInSecondLevel) {
        this.$emit("backToFirstLevel");
      } else {
        this.$emit("toggleMobileMenu");
      }
    },
  },
};
</script>

<template>
  <button
    class="menu-button"
    :class="{ 'is-open': mobileMenuIsOpen, 'is-back': isInSecondLevel }"
    @click="handleClick"
    :aria-label="buttonLabel"
  >
    <span class="icon-wrapper">
      <span class="line line-1"></span>
      <span class="line line-2"></span>
      <span class="line line-3"></span>
    </span>
  </button>
</template>

<style lang="scss">
.menu-button {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  .icon-wrapper {
    position: relative;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .line {
    position: absolute;
    width: 24px;
    height: 2px;
    background-color: #35887e;
    transition: all 0.3s ease, transform-origin 0.3s ease;

    &-1 {
      transform: translateY(-8px);
    }

    &-3 {
      transform: translateY(8px);
    }
  }

  &.is-open {
    .line {
      background-color: #000;

      &-1 {
        transform: translateY(0) rotate(45deg);
      }

      &-2 {
        opacity: 0;
      }

      &-3 {
        transform: translateY(0) rotate(-45deg);
      }
    }
  }

  &.is-back {
    .line {
      background-color: #000;

      &-1 {
        transform: translateY(-4.5px) rotate(-35deg) scaleX(0.7);
        transform-origin: center;
      }

      &-2 {
        opacity: 0;
      }

      &-3 {
        transform: translateY(4.5px) rotate(35deg) scaleX(0.7);
        transform-origin: center;
      }
    }
  }
}

@media (max-width: 960px) {
  .menu-button {
    display: flex;
  }
}
</style>
